import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||1920}
    height={undefined}
    viewBox="0 0 1920 260"
    style={{aspectRatio: 1920 / 260}}
    fill="none"
    {...props}
  >
    <path
      stroke="#435288"
      strokeDasharray="15.33 15.33"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M169.968 90h90.441c20.1 0 36.417 16.317 36.417 36.417v91.074c0 20.1-16.317 36.417-36.417 36.417h-91.074c-20.101 0-36.417-16.317-36.417-36.417V127.05c0-20.451 16.603-37.05 37.05-37.05Z"
    />
    <path
      fill="#fff"
      d="M286.221 126.421v91.074c0 14.244-11.564 25.808-25.808 25.808h-91.074c-14.244 0-25.808-11.564-25.808-25.808V127.05c0-14.594 11.846-26.441 26.441-26.441h90.441c14.244 0 25.808 11.564 25.808 25.808v.004Z"
      opacity={0.9}
    />
    <path
      fill="#24EAA8"
      d="M132.655 152.106a6.654 6.654 0 0 0 6.654-6.655 6.654 6.654 0 0 0-6.654-6.654 6.654 6.654 0 1 0 0 13.309Z"
    />
    <path
      fill="#FF7458"
      d="m304.887 205.961-7.955-13.926-7.959 13.926h15.914Z"
    />
    <path
      fill="#425596"
      d="M185.925 128.15c-26.284 21.494-14.383 64.419 19.294 69.655 6.013.934 11.493 4.737 15.007 10.255l6.804-3.653c-4.671-7.634-12.263-12.884-20.629-14.184-27.075-4.211-36.825-38.784-15.613-56.129 26.227-21.473 62.728 6.518 50.029 36.873-3.653 8.739-3.632 18.123 0 26.033l6.804-3.653c-2.534-5.874-2.478-12.842.269-19.417 15.745-37.595-29.435-72.311-61.962-45.776l-.003-.004Zm40.377 91.02c3.004 5.595 9.997 7.697 15.588 4.692l6.923-3.72c5.588-3.001 7.694-9.994 4.689-15.585l-2.36-4.396-27.2 14.613 2.36 4.396Zm4.406-8.018 13.678-7.348 2.357 4.385c1 1.862.3 4.194-1.565 5.194l-6.923 3.72a3.834 3.834 0 0 1-5.194-1.565l-2.357-4.386h.004Z"
    />
    <path
      fill="#24EAA8"
      d="M254.68 193.91a3.832 3.832 0 0 1-1.565 5.194l-31.146 16.732a3.84 3.84 0 0 1-5.201-1.561 3.838 3.838 0 0 1 1.569-5.198l31.146-16.732a3.833 3.833 0 0 1 5.194 1.565h.003Z"
    />
    <path
      fill="#FF7458"
      d="M203.449 143.986c8.08-4.339 18.185-1.296 22.529 6.787a3.833 3.833 0 0 0 5.194 1.566 3.834 3.834 0 0 0 1.565-5.194c-6.344-11.81-21.114-16.258-32.921-9.914a3.836 3.836 0 0 0 3.629 6.759l.004-.004Z"
    />
    <path
      stroke="#435288"
      strokeDasharray="15.33 15.33"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M401.884 34h90.441c20.1 0 36.417 16.316 36.417 36.417v91.074c0 20.1-16.317 36.417-36.417 36.417h-91.074c-20.101 0-36.417-16.317-36.417-36.417V71.05c0-20.45 16.603-37.05 37.05-37.05Z"
    />
    <path
      fill="#fff"
      d="M518.137 70.42v91.075c0 14.244-11.564 25.808-25.808 25.808h-91.074c-14.244 0-25.808-11.564-25.808-25.808V71.05c0-14.594 11.846-26.44 26.441-26.44h90.441c14.244 0 25.808 11.563 25.808 25.807v.004Z"
      opacity={0.9}
    />
    <path
      fill="#24EAA8"
      d="M364.571 96.106a6.654 6.654 0 0 0 0-13.31 6.654 6.654 0 1 0 0 13.31Z"
    />
    <path
      fill="#FF7458"
      d="m536.803 149.961-7.955-13.926-7.959 13.926h15.914Z"
    />
    <path
      stroke="#FF7458"
      strokeMiterlimit={10}
      strokeWidth={13}
      d="M488.136 86.263c0-5.082-4.161-9.244-9.244-9.244h-62.67c-5.082 0-9.243 4.162-9.243 9.244v49.812h81.157V86.263Z"
    />
    <path
      fill="#455793"
      d="M466.072 144.609a7.897 7.897 0 0 1-6.57 3.534h-23.894c-2.734 0-5.143-1.407-6.571-3.534H390.18c0 5.65 4.627 10.277 10.276 10.277h94.187c5.65 0 10.277-4.627 10.277-10.277h-38.858.01ZM468.374 99.344a3.214 3.214 0 0 0-.082-.243c-3.138-8.728-11.47-14.58-20.734-14.58-9.264 0-17.576 5.852-20.725 14.56-.03.08-.061.161-.081.242a21.892 21.892 0 0 0-1.215 7.229c0 2.471.415 4.921 1.215 7.209.02.091.051.172.091.263 3.149 8.707 11.471 14.559 20.725 14.559 9.254 0 17.596-5.862 20.714-14.539.041-.091.071-.192.092-.243a22.04 22.04 0 0 0 1.225-7.249c0-2.48-.416-4.92-1.215-7.198l-.01-.01Zm-5.711-1.65h-6.925c-.465-2.927-1.154-5.498-2.015-7.543a17.547 17.547 0 0 1 8.94 7.542Zm-17.616-4.415c1.134-3.412 2.298-4.232 2.511-4.242.222.02 1.377.83 2.521 4.242.435 1.306.8 2.794 1.083 4.414h-7.209c.284-1.62.648-3.108 1.094-4.414Zm-14.458 17.596a17.31 17.31 0 0 1-.547-4.333c0-1.468.183-2.926.547-4.333h8.272a61.647 61.647 0 0 0 0 8.666h-8.272Zm1.863 4.516h6.925c.466 2.926 1.154 5.487 2.015 7.543a17.515 17.515 0 0 1-8.94-7.543Zm6.925-17.698h-6.925a17.595 17.595 0 0 1 8.94-7.542c-.861 2.045-1.549 4.616-2.015 7.542Zm10.702 22.112c-1.134 3.412-2.299 4.232-2.511 4.242-.223-.02-1.377-.83-2.521-4.242-.436-1.306-.8-2.784-1.083-4.414h7.208c-.283 1.62-.648 3.108-1.083 4.414h-.01Zm1.65-8.93h-8.332a55.075 55.075 0 0 1-.162-4.333c0-1.468.06-2.916.162-4.333h8.332c.111 1.427.162 2.875.162 4.333 0 1.458-.051 2.906-.162 4.333Zm1.994 12.059c.861-2.046 1.55-4.617 2.015-7.543h6.925a17.65 17.65 0 0 1-8.94 7.543Zm10.803-12.059h-8.271c.101-1.417.151-2.875.151-4.333 0-1.458-.05-2.906-.151-4.333h8.271c.365 1.407.547 2.865.547 4.333s-.182 2.926-.547 4.333Z"
    />
    <path
      fill="#24EAA8"
      d="m453.398 120.248-.081-.051-2.744-1.458-1.205-.637-3.655-1.944-2.126-1.134-3.341-1.772.921 3.301.213.769 1.215 4.364.496 1.792 1.6 5.73 1.63-2.389 1.346-1.964 3.959 4.93 2.308-1.863-3.27-4.08-.688-.85 4.89-1.964-1.468-.78Z"
    />
    <path
      stroke="#435288"
      strokeDasharray="15.33 15.33"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M1468.51 55.098h83.79c18.62 0 33.74 15.117 33.74 33.74v84.379c0 18.623-15.12 33.74-33.74 33.74h-84.38c-18.62 0-33.74-15.117-33.74-33.74V89.424c0-18.947 15.38-34.326 34.33-34.326Z"
    />
    <path
      fill="#fff"
      d="M1576.21 88.842v84.379c0 13.197-10.71 23.911-23.91 23.911h-84.38c-13.19 0-23.91-10.714-23.91-23.911V89.425c0-13.522 10.98-24.497 24.5-24.497h83.79c13.2 0 23.91 10.713 23.91 23.91v.004Z"
      opacity={0.9}
    />
    <path
      fill="#24EAA8"
      d="M1433.94 112.643c3.4 0 6.16-2.76 6.16-6.165a6.165 6.165 0 1 0-12.33 0 6.166 6.166 0 0 0 6.17 6.165Z"
    />
    <path fill="#FF7458" d="m1593.51 162.537-7.37-12.902-7.38 12.902h14.75Z" />
    <path
      stroke="#24EAA8"
      strokeMiterlimit={10}
      strokeWidth={13}
      d="M1519.57 145.152v25.139l-9.77-9.766h-46.41a4.93 4.93 0 0 1-4.93-4.932v-34.167a4.93 4.93 0 0 1 4.93-4.932h30.86"
    />
    <path
      stroke="#FF7458"
      strokeMiterlimit={10}
      strokeWidth={13}
      d="M1562.5 96.702v34.166a4.93 4.93 0 0 1-4.93 4.932h-44.24l-9.77 9.766V96.702a4.931 4.931 0 0 1 4.93-4.933h49.08c2.72 0 4.93 2.206 4.93 4.933Z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7458"
      d="M1531.69 118.688c0-1.278.32-2.448.96-3.52a6.902 6.902 0 0 1 2.63-2.511c.55-.288.98-.72 1.3-1.287.31-.567.47-1.188.47-1.872 0-.684-.17-1.242-.48-1.773a3.58 3.58 0 0 0-1.29-1.26 3.492 3.492 0 0 0-1.76-.459c-.64 0-1.24.153-1.78.459-.54.306-.97.729-1.28 1.26-.32.531-.47 1.125-.47 1.773h-4.11c0-1.404.35-2.682 1.03-3.825a7.713 7.713 0 0 1 2.77-2.754c1.16-.684 2.44-1.026 3.85-1.026 1.4 0 2.68.342 3.83 1.026a7.873 7.873 0 0 1 2.77 2.754c.7 1.152 1.04 2.43 1.04 3.825s-.35 2.763-1.06 3.969a7.215 7.215 0 0 1-2.88 2.808c-.45.235-.79.568-1.04.991-.25.423-.38.9-.38 1.413h-4.1l-.02.009Zm2.21 7.641c-.6 0-1.1-.207-1.51-.621-.4-.414-.61-.918-.61-1.512s.21-1.08.61-1.485c.41-.405.91-.603 1.51-.603.59 0 1.08.198 1.48.603.41.405.6.9.6 1.485 0 .585-.19 1.098-.6 1.512-.4.414-.9.621-1.48.621Z"
    />
    <path
      fill="#455793"
      d="M1478.14 134.764a3.161 3.161 0 0 0-3.16 3.159 3.168 3.168 0 0 0 3.16 3.159c1.73 0 3.15-1.422 3.15-3.159a3.166 3.166 0 0 0-3.15-3.159ZM1491.12 134.764a3.161 3.161 0 0 0-3.16 3.159 3.168 3.168 0 0 0 3.16 3.159c1.73 0 3.16-1.422 3.16-3.159a3.174 3.174 0 0 0-3.16-3.159Z"
    />
    <path
      stroke="#435288"
      strokeDasharray="15.33 15.33"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M1678.16 105.129h84.36c18.74 0 33.96 15.218 33.96 33.965v84.941c0 18.747-15.22 33.965-33.96 33.965h-84.95c-18.74 0-33.96-15.218-33.96-33.965v-84.351c0-19.073 15.48-34.555 34.55-34.555Z"
    />
    <path
      fill="#fff"
      d="M1786.59 139.099v84.941c0 13.286-10.79 24.071-24.07 24.071h-84.94c-13.29 0-24.07-10.785-24.07-24.071v-84.354c0-13.612 11.04-24.661 24.66-24.661h84.35c13.28 0 24.07 10.785 24.07 24.071v.003Z"
      opacity={0.9}
    />
    <path
      fill="#24EAA8"
      d="M1704.95 144.953h-32.18a2.822 2.822 0 0 0-2.82 2.822v56.716a2.822 2.822 0 0 0 2.82 2.822h32.18c6.16 0 11.16 5.008 11.16 11.162a2.83 2.83 0 0 0 2.83 2.822c1.55 0 2.82-1.267 2.82-2.822v-56.716c0-9.268-7.54-16.806-16.81-16.806Zm11.16 16.806v44.158a16.685 16.685 0 0 0-11.16-4.248h-29.36V150.6h29.36c6.16 0 11.16 5.008 11.16 11.162v-.003Z"
    />
    <path
      fill="#425596"
      d="M1765.1 144.953h-32.18c-9.27 0-16.8 7.538-16.8 16.806v56.716a2.822 2.822 0 0 0 2.82 2.822c1.55 0 2.82-1.267 2.82-2.822 0-6.154 5.01-11.162 11.16-11.162h32.18a2.83 2.83 0 0 0 2.83-2.822v-56.716a2.83 2.83 0 0 0-2.83-2.822Zm-2.82 5.644v51.069h-29.36c-4.17 0-8.1 1.522-11.16 4.248v-44.155c0-6.154 5.01-11.162 11.16-11.162h29.36Z"
    />
    <path
      fill="#FF7458"
      d="M1763.1 210.697h-27.64c-5.41 0-9.81 4.401-9.81 9.814a2.828 2.828 0 0 0 2.82 2.822c1.56 0 2.82-1.267 2.82-2.822 0-2.299 1.87-4.17 4.17-4.17h27.64c1.55 0 2.82-1.267 2.82-2.822a2.828 2.828 0 0 0-2.82-2.822Z"
    />
    <path
      fill="#425596"
      d="M1702.93 210.697h-27.64a2.828 2.828 0 0 0-2.82 2.822 2.828 2.828 0 0 0 2.82 2.822h27.64c2.3 0 4.17 1.871 4.17 4.17a2.822 2.822 0 0 0 2.82 2.822c1.55 0 2.82-1.267 2.82-2.822 0-5.413-4.4-9.814-9.81-9.814Z"
    />
    <path
      fill="#24EAA8"
      d="M1643.36 163.056a6.207 6.207 0 1 0 0-12.413c-3.42 0-6.2 2.778-6.2 6.206a6.206 6.206 0 0 0 6.2 6.207Z"
    />
    <path fill="#FF7458" d="m1804 213.285-7.42-12.988-7.42 12.988H1804Z" />
    <path
      fill="#8CF9E7"
      fillOpacity={0.85}
      d="M1682 74h-56c-5.52 0-10-4.477-10-10V10c0-5.523 4.48-10 10-10h56c5.52 0 10 4.477 10 10v54c0 5.523-4.48 10-10 10ZM1367 243h-102c-5.52 0-10-4.477-10-10v-97c0-5.523 4.48-10 10-10h102c5.52 0 10 4.477 10 10v97c0 5.523-4.48 10-10 10Z"
      opacity={0.9}
    />
    <path
      fill="#fff"
      fillOpacity={0.85}
      d="M1948 243h-102c-5.52 0-10-4.477-10-10v-97c0-5.523 4.48-10 10-10h102c5.52 0 10 4.477 10 10v97c0 5.523-4.48 10-10 10Z"
      opacity={0.9}
    />
    <path
      fill="#8CF9E7"
      fillOpacity={0.85}
      d="M621 210h102c5.523 0 10-4.477 10-10v-97c0-5.523-4.477-10-10-10H621c-5.523 0-10 4.477-10 10v97c0 5.523 4.477 10 10 10Z"
      opacity={0.9}
    />
    <path
      fill="#fff"
      fillOpacity={0.85}
      d="M-17 182H85c5.523 0 10-4.477 10-10V75c0-5.523-4.477-10-10-10H-17c-5.523 0-10 4.477-10 10v97c0 5.523 4.477 10 10 10ZM1284 167h-64c-5.52 0-10-4.477-10-10V96c0-5.523 4.48-10 10-10h64c5.52 0 10 4.477 10 10v61c0 5.523-4.48 10-10 10ZM585 246h64c5.523 0 10-4.477 10-10v-61c0-5.523-4.477-10-10-10h-64c-5.523 0-10 4.477-10 10v61c0 5.523 4.477 10 10 10Z"
      opacity={0.9}
    />
    <path
      fill="#8CF9E7"
      fillOpacity={0.85}
      d="M44 86h64c5.523 0 10-4.477 10-10V15c0-5.523-4.477-10-10-10H44c-5.523 0-10 4.477-10 10v61c0 5.523 4.477 10 10 10ZM1884 142h64c5.52 0 10-4.477 10-10V71c0-5.523-4.48-10-10-10h-64c-5.52 0-10 4.477-10 10v61c0 5.523 4.48 10 10 10ZM1168 196h-23c-5.52 0-10-4.477-10-10v-21c0-5.523 4.48-10 10-10h23c5.52 0 10 4.477 10 10v21c0 5.523-4.48 10-10 10Z"
      opacity={0.9}
    />
    <path
      fill="#fff"
      fillOpacity={0.85}
      d="M783 122h23c5.523 0 10-4.477 10-10V91c0-5.523-4.477-10-10-10h-23c-5.523 0-10 4.477-10 10v21c0 5.523 4.477 10 10 10Z"
      opacity={0.9}
    />
    <path
      fill="#8CF9E7"
      fillOpacity={0.85}
      d="M850 140h15a3 3 0 0 0 3-3v-15a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v15a3 3 0 0 0 3 3Z"
      opacity={0.9}
    />
  </svg>
)
export default SvgComponent
